module.exports = __webpack_public_path__ + "static/media/PrintTagsLogo.5e800c04.png";